define('drops/magicWand/magicWand',[
    'jquery',
    'lq/drop',
    'drops/dynamicImage/dynamicImage',
    'lq/style',
    'magic-wand-min'
], function ($, Drop, DynamicImage, Style) {
    'use strict';

    var defaults = {
        data: {
            simplifierTolerance: 30
        }
    };

    var selectEvent = 'selected';

    var magicWandData = {
        colorThreshold: 15,
        currentThreshold: 15,
        blurRadius: 5,
        hatchLength: 4,
        hatchOffset: 0,
        simplifierTolerance: defaults.data.simplifierTolerance,
        imageInfo: null,
        cacheInd: null,
        mask: null,
        downPoint: null,
        allowDraw: false,
        firstDraw: true
    }

    function MagicWand(options) {
        Drop.call(this, $('<div />'), defaults, options);

        magicWandData.simplifierTolerance = this.data.simplifierTolerance;

        this.$image = $('<img />')
            .css({
                'width': '100%',
                'height': '100%',
                'overflow': 'hidden'
            })
            .appendTo(this.$element);

        this.$canvas = $('<canvas />')
            .css({
                'position': 'absolute',
                'top': '0px',
                'left': '0px',
                'width': '100%',
                'height': '100%',
                'overflow': 'hidden'
            })
            .appendTo(this.$element);


        Style.renderStyles(this, null, this.$image);

        this.hideWhenNecessary();

        this.applyEventTrigger('mouseEnter', 'mouseenter');
    };

    Drop.extend(MagicWand, DynamicImage);

    MagicWand.typeName = 'MagicWand';

    MagicWand.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        this.applyPosition();

        var self = this;

        if (this.isEventEnabled(selectEvent)) {
            this.$canvas.on('mouseup', function (e) {
                magicWandData.allowDraw = false;
                magicWandData.currentThreshold = magicWandData.colorThreshold;

                if (e.button === 0 && magicWandData.mask) {
                    self.triggerEvent(self.data.eventing[selectEvent].raisedEventName, JSON.stringify(self.compressMaskData()));
                }
            });

            this.$canvas.on('mousedown', function (e) {

                if (magicWandData.firstDraw) {
                    self.initCanvas();
                    magicWandData.firstDraw = false;
                }

                if (e.button === 0) {
                    magicWandData.allowDraw = true;
                    magicWandData.downPoint = self.getMousePosition(e);
                    self.drawMask(magicWandData.downPoint.x, magicWandData.downPoint.y);
                } else {
                    magicWandData.allowDraw = false;
                }
            });

            this.$canvas.on('mousemove', function (e) {
                if (magicWandData.allowDraw) {
                    var p = self.getMousePosition(e);
                    if (p.x != magicWandData.downPoint.x || p.y != magicWandData.downPoint.y) {
                        var dx = p.x - magicWandData.downPoint.x,
                            dy = p.y - magicWandData.downPoint.y,
                            len = Math.sqrt(dx * dx + dy * dy),
                            adx = Math.abs(dx),
                            ady = Math.abs(dy),
                            sign = adx > ady ? dx / adx : dy / ady;
                        sign = sign < 0 ? sign / 5 : sign / 3;
                        var thres = Math.min(Math.max(magicWandData.colorThreshold + Math.floor(sign * len), 1), 255);
                        if (thres != magicWandData.currentThreshold) {
                            magicWandData.currentThreshold = thres;
                            self.drawMask(magicWandData.downPoint.x, magicWandData.downPoint.y);
                        }
                    }
                }
            });
        }
    };

    MagicWand.prototype.compressMaskData = function () {
        var cs = MagicWandClass.traceContours(magicWandData.mask);
        return MagicWandClass.simplifyContours(cs, magicWandData.simplifierTolerance, 0);
    }


    MagicWand.prototype.drawBorderFromSimplifiedData = function (cs, clearCanvas) {

        if (magicWandData.firstDraw) {
            this.initCanvas();
            magicWandData.firstDraw = false;
        }

        var ctx = magicWandData.imageInfo.context;

        if (clearCanvas) {
            ctx.clearRect(0, 0, magicWandData.imageInfo.width, magicWandData.imageInfo.height);
        }

        for (var i = 0; i < cs.length; ++i) {
            ctx.beginPath();

            var color = cs[i].inner ? 'red' : 'blue';
            this.drawArea(ctx, cs[i].points, color);
        }
    }

    MagicWand.prototype.drawArea = function (ctx, points, color) {
        ctx.moveTo(points[0].x, points[0].y);
        for (var j = 1; j < points.length; j++) {
            ctx.lineTo(points[j].x, points[j].y);
        }

        if (color) {
            ctx.strokeStyle = color;
            ctx.stroke();
        }
    }

    MagicWand.prototype.initCanvas = function () {
        var cvs = this.$canvas.get(0);
        var img = this.$image.get(0);

        cvs.width = img.width;
        cvs.height = img.height;

        magicWandData.imageInfo = {
            width: img.width,
            height: img.height,
            context: cvs.getContext("2d")
        };
        magicWandData.mask = null;

        var tempCtx = document.createElement("canvas").getContext("2d");
        tempCtx.canvas.width = magicWandData.imageInfo.width;
        tempCtx.canvas.height = magicWandData.imageInfo.height;
        tempCtx.drawImage(img, 0, 0, img.width, img.height);

        magicWandData.imageInfo.data = tempCtx.getImageData(0, 0, magicWandData.imageInfo.width, magicWandData.imageInfo.height);
    };

    MagicWand.prototype.drawMask = function (x, y) {

        var image = {
            data: magicWandData.imageInfo.data.data,
            width: magicWandData.imageInfo.width,
            height: magicWandData.imageInfo.height,
            bytes: 4
        };

        magicWandData.mask = MagicWandClass.floodFill(image, x, y, magicWandData.currentThreshold);
        magicWandData.mask = MagicWandClass.gaussBlurOnlyBorder(magicWandData.mask, magicWandData.blurRadius);

        this.drawBorderFromSimplifiedData(this.compressMaskData(), true);
    };

    MagicWand.prototype.getMousePosition = function (e) {
        var p = $(e.target).offset(),
            x = Math.round((e.clientX || e.pageX) - p.left),
            y = Math.round((e.clientY || e.pageY) - p.top);
        return {
            x: x,
            y: y
        };
    };

    MagicWand.prototype.updateImage = function (src, alt) {
        this.$image
            .attr('alt', alt)
            .attr('src', src);

        if (this.data.hideWhenEmpty)
            this.show();
    };

    MagicWand.prototype.licquidMethod_select = function (args) {
        this.drawBorderFromSimplifiedData(JSON.parse(args.selection), true);
    };

    return MagicWand;
});
